var _style, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPicture = function SvgPicture(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgPicture",
    x: "0px",
    y: "0px",
    width: "22px",
    height: "17.6px",
    viewBox: "0 0 22 17.6",
    style: {
      enableBackground: "new 0 0 22 17.6"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgPicture{fill:#B5B5B5;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    className: "svgPicture svgBase svgHover svgSelect",
    d: "M19.2,0H2.8C1.4,0,0.3,1.1,0.3,2.4v12.7c0,1.3,1.1,2.4,2.4,2.4h16.5c1.3,0,2.4-1.1,2.4-2.4V2.4 C21.7,1.1,20.6,0,19.2,0z M1.9,10.5l3.7-2.9l8.8,8.5H2.7c-0.5,0-0.9-0.4-0.9-0.9l0,0V10.5z M1.9,2.4c0-0.5,0.4-0.9,0.9-0.9h16.5 c0.5,0,0.9,0.4,0.9,0.9V13l-5-4.7C14.8,7.9,14.4,7.8,14,8l0,0l-2.7,2.8L6.3,6C6,5.7,5.6,5.6,5.2,5.8L1.9,8.5L1.9,2.4z M20.1,15.2 c0,0.5-0.4,0.8-0.9,0.8h-2.5c0,0,0-0.1-0.1-0.1l-4.2-4l2-2.1L20.1,15.2z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPicture, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/picture.a4f6185a.svg";
export { ForwardRef as ReactComponent };